export enum ServiceEnum {
  CONTADO = '40',
  COD = '50',
  CREDITO = '60',
  STANDARD = '60',
  DOCUMENT = '61',
  INTERNATIONAL = '62',
  ECONOMIC = '64',
  NATIONAL_LOCKER = '81',
  VACIO = '0',
}
export enum ShipmentService {
  STANDARD = 60,
  DOCUMENT = 61,
  DOCUMENT_INTERNATIONAL = 62,
  INTERNATIONAL = 62,
  STANDARD_INTERNATIONAL = 63,
  ECONOMIC = 64,
  SAVER = 70,
  NATIONAL_LOCKER = 81,
  INTERNAL_MAIL = 99,
}
